import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import "./Navbar.css";

import { useAuth } from "../../../firebase/AuthProvider";
import EventNotification from "../../../interfaces/eventNotification/EventNotification";
import SlideOutPanel from "../Sidenav/SlideOutPanel";
import HeaderComponent from "./HeaderComponent";
import SideBarComponent from "./SideBarComponent";
import { Conversation } from "../../../services/chatService/ChatService";
import Loader from "../../components/loader/Loader";

interface NavbarProps {
  toggleDarkMode: () => void;
  isDarkMode: boolean;
  children?: React.ReactNode;
}

interface NavItemProps {
  name: string;
  icon: IconDefinition;
  onClick: () => void;
  path: string;
  children?: React.ReactNode;
}

const NavItem: React.FC<NavItemProps & { isActive: boolean }> = ({
  name,
  icon,
  isActive,
  onClick,
  path,
  children,
}) => {
  return (
    <Link
      to={path}
      className={`flex items-center p-2 cursor-pointer`}
      onClick={onClick}
    >
      <span className="mr-2 text-xl">
        <FontAwesomeIcon icon={icon} />
      </span>
      <span>{name}</span>
    </Link>
  );
};

const Navbar: React.FC<NavbarProps> = ({
  toggleDarkMode,
  isDarkMode,
  children,
}) => {

  const [isShowSidebarMobile, setIsShowSidebarMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState<EventNotification[]>([]);
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("notifications");
  const { currentUser, currentRoles } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
 const navigate = useNavigate();

   useEffect(() => {
      if (currentRoles) {
        setLoading(false);
        // currentRoles.map((role) => {
        //   if (role.name === 'OWNER') { 
        //     navigate('/dashboard/owner')
        //   }
        // })
      }
    }, [currentRoles]);
    const handleShowSidebar = () => {setIsShowSidebarMobile(true);
      console.log("HandleSidebar call");
      
    }

    const handleCloseSidebar = () => setIsShowSidebarMobile(false);

  return (
    <>
        {loading && <Loader />}
      {currentUser &&
        currentRoles 
        &&
         (
          <>
            <SideBarComponent isShowSidebarMobile={isShowSidebarMobile} />
            {
                isShowSidebarMobile &&
                <div onClick={handleCloseSidebar} className="sidebar_overlay">

            </div>
            }
            <div className="main_content_wrapper">
              <HeaderComponent handleShowSidebar={handleShowSidebar}/>
              <div className="main_content">{children}</div>
            </div>
          </>
        )}
    </>
  );
};

export default Navbar;
